import { useEffect, useRef } from 'react';

import GreenpillFAQs from './GreenpillFAQs';
import Overlay from '../../ui/Overlay';
import ButtonNew from '../../ui/ButtonNew';
import Feedbackclose from '../../assets/icons/Feedbackclose';

function GreenpillFAQModal({ close }) {
    const myRef = useRef({ close });

    useEffect(() => {
        function handleClickOutside(e) {
            // Close the modal if the click is outside the modal content
            if (myRef.current && !myRef.current.contains(e.target)) {
                close();
            }
        }

        // Add the event listener to close modal on outside click
        document.addEventListener('mousedown', handleClickOutside, true);

        // Clean up the event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [close]);

    return (
        <Overlay isBlur={false}>
            <div
                style={{
                    borderRadius: '8px',
                }}
                className="absolute bg-grayBgNormal backdrop-blur-3xl rounded-lg left-[50%] p-6 w-[90%] max-h-[90vh] overflow-auto main   md:w-[40%]    border border-borderUnderline    translate-x-[-50%] translate-y-[-50%] top-[50%]"
            // className="absolute bg-[rgba(52,53,52,.85)] backdrop-blur-3xl rounded-lg left-[50%] p-6 w-[90%] max-h-[90vh] overflow-auto main   md:w-[40%]    border border-[#2a2a2a]    translate-x-[-50%] translate-y-[-50%] top-[50%]"
            >
                <div ref={myRef} className="relative w-full h-full">
                    <ButtonNew
                        onClick={() => {
                            close();
                        }}
                        variant="closeNeutral"
                        size="xs"
                        shape="oval"
                        className="absolute z-[9999] top-0 right-0 !p-0"
                        fixedMinWidth
                        minWidthClass="min-w-[2.5rem]"
                    >
                        <Feedbackclose />
                    </ButtonNew>
                    <h1
                        className="text-2xl mb-4 font-semibold text-tPrimary "
                        style={{
                            textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                        }}
                    >
                        Frequently Asked Questions
                    </h1>
                    <GreenpillFAQs />
                </div>
            </div>
        </Overlay>
    );
}

export default GreenpillFAQModal;
